import { useState, useRef } from 'react';
import { Tree, Dialog, Form, Input, Button, Cascader, DatePicker, MessagePlugin,Textarea } from 'tdesign-react';
import { Building2, Users, Mail, Phone, MapPin, Calendar, Plus, Edit2, Trash2 } from 'lucide-react';
interface Department {
  id: number;
  name: string;
  parentId: number;
  description: string;
  leader: string;
  phone: string;
  email: string;
  address: string;
  createTime: string;
  employeeCount: number;
  children?: Department[];
}

const initialDepartmentData: Department[] = [
  {
    id: 1,
    name: '总部',
    parentId: 0,
    description: '公司总部管理部门',
    leader: '张三',
    phone: '010-12345678',
    email: 'zhang@company.com',
    address: '北京市朝阳区建国路88号',
    createTime: '2024-01-01',
    employeeCount: 150,
    children: [
      {
        id: 11,
        name: '行政部',
        parentId: 1,
        description: '负责公司行政事务管理',
        leader: '李四',
        phone: '010-12345679',
        email: 'li@company.com',
        address: '北京市朝阳区建国路88号1号楼',
        createTime: '2024-01-10',
        employeeCount: 20,
        children: [
          {
            id: 111,
            name: '人事组',
            parentId: 11,
            description: '负责员工招聘和人事管理',
            leader: '王五',
            phone: '010-12345680',
            email: 'wang@company.com',
            address: '北京市朝阳区建国路88号1号楼1层',
            createTime: '2024-02-01',
            employeeCount: 5,
          },
          {
            id: 112,
            name: '后勤组',
            parentId: 11,
            description: '负责公司后勤保障',
            leader: '赵六',
            phone: '010-12345681',
            email: 'zhao@company.com',
            address: '北京市朝阳区建国路88号1号楼2层',
            createTime: '2024-02-15',
            employeeCount: 8,
          },
        ],
      },
      {
        id: 12,
        name: '财务部',
        parentId: 1,
        description: '负责公司财务管理和资金运作',
        leader: '孙七',
        phone: '010-12345682',
        email: 'sun@company.com',
        address: '北京市朝阳区建国路88号2号楼',
        createTime: '2024-01-15',
        employeeCount: 15,
        children: [
          {
            id: 121,
            name: '会计组',
            parentId: 12,
            description: '负责公司会计核算',
            leader: '周八',
            phone: '010-12345683',
            email: 'zhou@company.com',
            address: '北京市朝阳区建国路88号2号楼1层',
            createTime: '2024-03-01',
            employeeCount: 6,
          },
          {
            id: 122,
            name: '出纳组',
            parentId: 12,
            description: '负责公司资金收付',
            leader: '吴九',
            phone: '010-12345684',
            email: 'wu@company.com',
            address: '北京市朝阳区建国路88号2号楼2层',
            createTime: '2024-03-10',
            employeeCount: 4,
          },
        ],
      },
    ],
  },
  {
    id: 2,
    name: '研发中心',
    parentId: 0,
    description: '负责公司产品研发和技术创新',
    leader: '郑十',
    phone: '010-12345685',
    email: 'zheng@company.com',
    address: '北京市海淀区中关村大街1号',
    createTime: '2024-02-01',
    employeeCount: 80,
    children: [
      {
        id: 21,
        name: '前端开发部',
        parentId: 2,
        description: '负责前端技术开发',
        leader: '钱十一',
        phone: '010-12345686',
        email: 'qian@company.com',
        address: '北京市海淀区中关村大街1号A座',
        createTime: '2024-02-10',
        employeeCount: 30,
      },
      {
        id: 22,
        name: '后端开发部',
        parentId: 2,
        description: '负责后端技术开发',
        leader: '刘十二',
        phone: '010-12345687',
        email: 'liu@company.com',
        address: '北京市海淀区中关村大街1号B座',
        createTime: '2024-02-15',
        employeeCount: 35,
      },
      {
        id: 23,
        name: '测试部',
        parentId: 2,
        description: '负责产品质量测试',
        leader: '陈十三',
        phone: '010-12345688',
        email: 'chen@company.com',
        address: '北京市海淀区中关村大街1号C座',
        createTime: '2024-03-01',
        employeeCount: 15,
      },
    ],
  },
  {
    id: 3,
    name: '市场部',
    parentId: 0,
    description: '负责公司市场推广和品牌建设',
    leader: '杨十四',
    phone: '010-12345689',
    email: 'yang@company.com',
    address: '北京市东城区王府井大街1号',
    createTime: '2024-01-20',
    employeeCount: 40,
    children: [
      {
        id: 31,
        name: '品牌组',
        parentId: 3,
        description: '负责品牌形象塑造',
        leader: '黄十五',
        phone: '010-12345690',
        email: 'huang@company.com',
        address: '北京市东城区王府井大街1号1层',
        createTime: '2024-02-01',
        employeeCount: 10,
      },
      {
        id: 32,
        name: '销售组',
        parentId: 3,
        description: '负责产品销售',
        leader: '徐十六',
        phone: '010-12345691',
        email: 'xu@company.com',
        address: '北京市东城区王府井大街1号2层',
        createTime: '2024-02-10',
        employeeCount: 25,
      },
    ],
  },
];

const findDepartmentById = (departments: Department[], id: number): Department | undefined => {
  for (const dept of departments) {
    if (dept.id === id) {
      return dept;
    }
    if (dept.children) {
      const found = findDepartmentById(dept.children, id);
      if (found) return found;
    }
  }
  return undefined;
};

const findParentById = (departments: Department[], id: number): Department | undefined => {
  for (const dept of departments) {
    if (dept.children?.some(child => child.id === id)) {
      return dept;
    }
    if (dept.children) {
      const found = findParentById(dept.children, id);
      if (found) return found;
    }
  }
  return undefined;
};

const removeDepartmentById = (departments: Department[], id: number): Department[] => {
  return departments.filter(dept => {
    if (dept.id === id) return false;
    if (dept.children) {
      dept.children = removeDepartmentById(dept.children, id);
    }
    return true;
  });
};

const updateDepartmentById = (departments: Department[], id: number, updates: Partial<Department>): Department[] => {
  return departments.map(dept => {
    if (dept.id === id) {
      return { ...dept, ...updates };
    }
    if (dept.children) {
      dept.children = updateDepartmentById(dept.children, id, updates);
    }
    return dept;
  });
};

const addDepartment = (departments: Department[], newDept: Department): Department[] => {
  if (newDept.parentId === 0) {
    return [...departments, newDept];
  }
  return departments.map(dept => {
    if (dept.id === newDept.parentId) {
      return { ...dept, children: [...(dept.children || []), newDept] };
    }
    if (dept.children) {
      dept.children = addDepartment(dept.children, newDept);
    }
    return dept;
  });
};

const getAllDepartmentIds = (departments: Department[], ids: number[] = []): number[] => {
  departments.forEach(dept => {
    ids.push(dept.id);
    if (dept.children) {
      getAllDepartmentIds(dept.children, ids);
    }
  });
  return ids;
};

const buildSelectOptions = (departments: Department[], prefix = ''): { label: string; value: number; children?: { label: string; value: number }[] }[] => {
  let options: { label: string; value: number; children?: { label: string; value: number }[] }[] = [];
  departments.forEach(dept => {
    options.push({ label: prefix + dept.name, value: dept.id });
    if (dept.children) {
      options[options.length - 1].children = buildSelectOptions(dept.children, '');
    }
  });
  return options;
};

export default function DepartmentManage() {
  const [departments, setDepartments] = useState<Department[]>(initialDepartmentData);
  const [selectedDept, setSelectedDept] = useState<Department | null>(null);
  const [dialogVisible, setDialogVisible] = useState(false);
  const [editingDept, setEditingDept] = useState<Department | null>({} as Department & { id: number });
  const formRef = useRef<any>(null);

  const handleTreeChange = (item: any) => {
    const selectedId = item?.node?.value !== undefined ? item.node.value : item;
    const dept = findDepartmentById(departments, selectedId);
    if (dept) {
      setSelectedDept(dept);
    }
  };

  const handleAdd = () => {
    setEditingDept({} as Department & { id: number });
    setDialogVisible(true);
  };

  const handleEdit = (id: number) => {
    const dept = findDepartmentById(departments, id);
    if (!dept) {
      MessagePlugin.warning('部门不存在');
      return;
    }
    setSelectedDept(dept);
    setEditingDept(dept);
    setDialogVisible(true);
  };

  const handleDelete = (id: number) => {
    const dept = findDepartmentById(departments, id);
    if (!dept) {
      MessagePlugin.warning('部门不存在');
      return;
    }
    if (dept.children?.length) {
      MessagePlugin.warning('该部门下有子部门，无法删除');
      return;
    }
    const newDepartments = removeDepartmentById(departments, id);
    setDepartments(newDepartments);
    if (selectedDept?.id === id) {
      setSelectedDept(null);
    }
    MessagePlugin.success('删除成功');
  };

  const handleSubmit = async () => {
    const validateResult = await formRef.current?.validate();
    if (validateResult !== true && Object.keys(validateResult).length > 0) {
      MessagePlugin.warning('请完善表单信息');
      return;
    }
    const values = formRef.current?.getFieldsValue(true);
    
    if (editingDept) {
      const updated = updateDepartmentById(departments, editingDept.id, values);
      setDepartments(updated);
      const newDept = findDepartmentById(updated, editingDept.id);
      if (newDept) setSelectedDept(newDept);
      MessagePlugin.success('修改成功');
    } else {
      const allIds = getAllDepartmentIds(departments);
      const maxId = Math.max(...allIds, 0);
      const newDept: Department = {
        ...values,
        id: maxId + 1,
        parentId: values.parentId || 0,
        createTime: values.createTime || new Date().toISOString().split('T')[0],
      };
      const updated = addDepartment(departments, newDept);
      setDepartments(updated);
      MessagePlugin.success('新增成功');
    }
    setDialogVisible(false);
    setEditingDept({} as Department & { id: number });
  };

  const buildTreeData = (depts: Department[]): any[] => {
    return depts.map((dept) => ({
      label: (
        <div className="flex items-center justify-between w-full">
          <span>{dept.name}</span>
          <div className="flex gap-1">
            <button
              onClick={(e) => {
                e.stopPropagation();
                handleEdit(dept.id);
              }}
              className="p-1 hover:bg-gray-100 rounded text-gray-500 hover:text-blue-600 transition-colors"
              title="修改"
            >
              <Edit2 className="w-4 h-4" />
            </button>
            <button
              onClick={(e) => {
                e.stopPropagation();
                handleDelete(dept.id);
              }}
              className={`p-1 hover:bg-gray-100 rounded text-gray-500 hover:text-red-600 transition-colors ${dept.children?.length ? 'opacity-50 cursor-not-allowed' : ''}`}
              title="删除"
              disabled={!!dept.children?.length}
            >
              <Trash2 className="w-4 h-4" />
            </button>
          </div>
        </div>
      ),
      value: dept.id,
      children: dept.children?.length ? buildTreeData(dept.children) : undefined,
    }));
  };

  const treeData = buildTreeData(departments);
  const allIds = getAllDepartmentIds(departments);
  const selectOptions = buildSelectOptions(departments);

  return (
    <div className="flex h-[calc(100vh-6rem)]">
      <div className="w-80 bg-white border-r border-gray-200 flex flex-col">
        <div className="p-4 border-b border-gray-100 flex justify-between items-center">
          <h2 className="text-lg font-semibold">部门结构</h2>
          <Button
            theme="primary"
            variant="text"
            size="small"
            icon={<Plus className="w-4 h-4" />}
            onClick={handleAdd}
          >
            新增
          </Button>
        </div>
        <div className="flex-1 overflow-auto p-4">
          <Tree
            data={treeData}
            defaultExpanded={allIds}
            onClick={(value) => handleTreeChange(value)}
          />
        </div>
      </div>

      <div className="flex-1 overflow-auto p-6">
        {selectedDept ? (
          <div className="max-w-3xl mx-auto">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center">
                <Building2 className="w-6 h-6 text-blue-600" />
              </div>
              <div>
                <h2 className="text-xl font-bold">{selectedDept.name}</h2>
                <p className="text-gray-500 text-sm">部门详情</p>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4 mb-6">
              <div className="bg-white rounded-xl p-4 border border-gray-100">
                <div className="flex items-center gap-2 text-gray-500 text-sm mb-2">
                  <Users className="w-4 h-4" />
                  <span>员工数量</span>
                </div>
                <p className="text-2xl font-bold text-gray-900">{selectedDept.employeeCount} 人</p>
              </div>
              <div className="bg-white rounded-xl p-4 border border-gray-100">
                <div className="flex items-center gap-2 text-gray-500 text-sm mb-2">
                  <Calendar className="w-4 h-4" />
                  <span>创建时间</span>
                </div>
                <p className="text-lg font-semibold text-gray-900">{selectedDept.createTime}</p>
              </div>
            </div>

            <div className="bg-white rounded-xl border border-gray-100 overflow-hidden">
              <div className="p-4 border-b border-gray-100 bg-gray-50">
                <h3 className="font-semibold">基本信息</h3>
              </div>
              <div className="p-6 space-y-4">
                <div className="flex items-start gap-4">
                  <div className="w-8 h-8 bg-gray-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Building2 className="w-4 h-4 text-gray-500" />
                  </div>
                  <div>
                    <p className="text-sm text-gray-500">部门名称</p>
                    <p className="font-medium">{selectedDept.name}</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-8 h-8 bg-gray-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Users className="w-4 h-4 text-gray-500" />
                  </div>
                  <div>
                    <p className="text-sm text-gray-500">部门负责人</p>
                    <p className="font-medium">{selectedDept.leader}</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-8 h-8 bg-gray-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Phone className="w-4 h-4 text-gray-500" />
                  </div>
                  <div>
                    <p className="text-sm text-gray-500">联系电话</p>
                    <p className="font-medium">{selectedDept.phone}</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-8 h-8 bg-gray-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Mail className="w-4 h-4 text-gray-500" />
                  </div>
                  <div>
                    <p className="text-sm text-gray-500">邮箱</p>
                    <p className="font-medium">{selectedDept.email}</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-8 h-8 bg-gray-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <MapPin className="w-4 h-4 text-gray-500" />
                  </div>
                  <div>
                    <p className="text-sm text-gray-500">地址</p>
                    <p className="font-medium">{selectedDept.address}</p>
                  </div>
                </div>

                <div className="pt-4 border-t border-gray-100">
                  <p className="text-sm text-gray-500 mb-2">部门描述</p>
                  <p className="text-gray-700">{selectedDept.description}</p>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="h-full flex flex-col items-center justify-center text-gray-400">
            <Building2 className="w-16 h-16 mb-4" />
            <p className="text-lg">请选择一个部门查看详情</p>
          </div>
        )}
      </div>

      <Dialog
        header={editingDept ? '修改部门' : '新增部门'}
        visible={dialogVisible}
        onClose={() => {
          setDialogVisible(false);
          setEditingDept({} as Department & { id: number });
        }}
        onConfirm={handleSubmit}
        confirmBtn={editingDept ? '保存修改' : '确认创建'}
        width={500}
        key={editingDept ? `edit-${editingDept.id}` : 'add-new'}
      >
        <Form ref={formRef} initialData={editingDept || {}} labelWidth={100}>
          <Form.FormItem label="上级部门" name="parentId">
            <Cascader
              lazy
              options={selectOptions}
              showAllLevels
              size="medium"
              trigger="click"
              valueMode="onlyLeaf"
              valueType="single"
            />
          </Form.FormItem>
          <Form.FormItem
            label="部门名称"
            name="name"
            rules={[{ required: true, message: '请输入部门名称' }]}
          >
            <Input placeholder="请输入部门名称" />
          </Form.FormItem>
          <Form.FormItem label="负责人" name="leader">
            <Input placeholder="请输入负责人" />
          </Form.FormItem>
          <Form.FormItem label="联系电话" name="phone" rules={[
            { pattern: /^(1[3-9]\d{9}|0\d{2,3}-?\d{7,8})$/, message: '请输入正确的手机号或座机号格式' }
          ]}>
            <Input placeholder="请输入联系电话" />
          </Form.FormItem>
          <Form.FormItem label="邮箱" name="email" rules={[
            { pattern: /^[\w.-]+@[\w-]+\.[\w.-]+$/, message: '请输入正确的邮箱格式' }
          ]}>
            <Input placeholder="请输入邮箱" />
          </Form.FormItem>
          <Form.FormItem label="地址" name="address">
            <Input placeholder="请输入地址" />
          </Form.FormItem>
          <Form.FormItem label="部门描述" name="description">
            <Textarea placeholder="请输入部门描述" rows={3} />
          </Form.FormItem>
          <Form.FormItem label="员工数量" name="employeeCount">
            <Input type="number" placeholder="请输入员工数量" />
          </Form.FormItem>
          <Form.FormItem label="创建时间" name="createTime">
            <DatePicker mode="date" presetsPlacement="bottom" />
          </Form.FormItem>
        </Form>
      </Dialog>
    </div>
  );
}